<template>
  <nav class="navbar navbar-expand-lg">
    <button
      :data-target="`#${id}`"
      :aria-controls="id"
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      aria-expanded="false"
      aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"/>
    </button>
    <div
      :id="id"
      class="collapse navbar-collapse">
      <slot/>
    </div>
  </nav>
</template>

<script>
export default {
  created () {
    this.id = `navbar-${this.$id.gen()}`
  },

  data () {
    return {
      id: null
    }
  },

  name: 'AppNavbar'
}
</script>
